import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/home";
import { DomainList } from "./pages/domains/DomainList";
import { DomainPurchase } from "./pages/domains/DomainPurchase";
import Profilo from "./pages/profilo";
import Login from "./pages/login";
import Register from "./pages/register";
import Layout from "./constants/layout";
import ListaApp from "./pages/listaApp";
import StoreApp from "./pages/storeApp";
import DettaglioApp from "./pages/dettaglioApp";
import CreateApp from "./pages/createApp";
import { TermsOfService } from "./pages/acceptance_documents/TermsOfService";
import { Privacy } from "./pages/acceptance_documents/Privacy";
import { AcceptableUse } from "./pages/acceptance_documents/AcceptableUse";
import RecoverPassword from "./pages/recover_password";
import ConfirmEmail from "./pages/confirm_email";
import ResetPassword from "./pages/ResetPassword";
import { Create as CreateBuilder } from "./pages/builder/Create";
import { Templates as TemplatesBuilder } from "./pages/builder/Templates";
import { List as BuilderList } from "./pages/builder/List";
import ProjectUidHandler from "./utils/ProjectUidHandler";

import { AB_Home } from "./pages/AB_Home";
import { AB_Website } from "./pages/AB_Website";
import { AB_Flow } from "./pages/AB_Flow";
import { AB_CRM } from "./pages/AB_CRM";
import { AB_AI_Studio } from "./pages/AB_AI_Studio";
import { AB_AI_Assistant } from "./pages/AB_AI_Assistant";

export default function Router() {
    return (
        <BrowserRouter>
            <ProjectUidHandler />
            <Routes>
                <Route path="/" element={<Navigate to="/login" />} />

                <Route
                    path="/home"
                    element={
                        <Layout>
                            <AB_Home />
                        </Layout>
                    }
                />

                <Route
                    path="/website"
                    element={
                        <Layout>
                            <AB_Website />
                        </Layout>
                    }
                />

                <Route
                    path="/flow"
                    element={
                        <Layout>
                            <AB_Flow />
                        </Layout>
                    }
                />

                <Route
                    path="/crm"
                    element={
                        <Layout>
                            <AB_CRM />
                        </Layout>
                    }
                />

                <Route
                    path="/ai-assistant"
                    element={
                        <Layout>
                            <AB_AI_Assistant />
                        </Layout>
                    }
                />

                <Route
                    path="/ai-studio"
                    element={
                        <Layout>
                            <AB_AI_Studio />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/home"
                    element={
                        <Layout>
                            <Home />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/domains"
                    element={
                        <Layout>
                            <DomainList />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/domains/purchase"
                    element={
                        <Layout>
                            <DomainPurchase />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/builder/create"
                    element={
                        <Layout>
                            <CreateBuilder />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/builder/create/templates"
                    element={
                        <Layout>
                            <TemplatesBuilder />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/builder/list"
                    element={
                        <Layout>
                            <BuilderList />
                        </Layout>
                    }
                />

                <Route
                    path="/profile"
                    element={
                        <Layout>
                            <Profilo />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/myapps/:appName"
                    element={
                        <Layout>
                            <DettaglioApp />
                        </Layout>
                    }
                />
                <Route
                    path="/pro/myapps/:appName/:tabName"
                    element={
                        <Layout>
                            <DettaglioApp />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/app"
                    element={
                        <Layout>
                            <StoreApp />
                        </Layout>
                    }
                />

                <Route
                    path="/pro/myapps"
                    element={
                        <Layout>
                            <ListaApp />
                        </Layout>
                    }
                />

                <Route path="/login" element={<Login />} />

                <Route path="/confirm_email/:token" element={<ConfirmEmail />} />

                <Route path="/recover_password" element={<RecoverPassword />} />
                <Route path="/reset_password/:token" element={<ResetPassword />} />

                
                <Route path="/terms_of_service" element={<TermsOfService />} />
                <Route path="/privacy" element={<Privacy />} />
                <Route path="/acceptable_use" element={<AcceptableUse />} />

                <Route
                    path="/pro/create-app/:app_id"
                    element={
                        <Layout>
                            <CreateApp />
                        </Layout>
                    }
                />

                <Route path="/*" element={<Navigate to="/" />} />
            </Routes>
        </BrowserRouter>
    );
}
